var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waterfall-container"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,class:'waterfall-item col-' + (index % _vm.columnCount)},[_c('img',{attrs:{"src":item.image,"alt":"waterfall image"}}),_c('p',[_vm._v(_vm._s(item.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }